"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZipPattern = exports.getAddressObject = exports.getLocationObject = exports.isTestStore = exports.TestStoreSearch = exports.provincesABR = void 0;

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _trim2 = _interopRequireDefault(require("lodash/trim"));

var _split2 = _interopRequireDefault(require("lodash/split"));

var _includes2 = _interopRequireDefault(require("lodash/includes"));

var _parseInt2 = _interopRequireDefault(require("lodash/parseInt"));

var _toLower2 = _interopRequireDefault(require("lodash/toLower"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


var states = ['ALABAMA', 'ALASKA', 'ARIZONA', 'ARKANSAS', 'CALIFORNIA', 'COLORADO', 'CONNECTICUT', 'DELAWARE', 'FLORIDA', 'GEORGIA', 'HAWAII', 'IDAHO', 'ILLINOIS', 'INDIANA', 'IOWA', 'KANSAS', 'KENTUCKY', 'LOUISIANA', 'MAINE', 'MARYLAND', 'MASSACHUSETTS', 'MICHIGAN', 'MINNESOTA', 'MISSISSIPPI', 'MISSOURI', 'MONTANA', 'NEBRASKA', 'NEVADA', 'NEW HAMPSHIRE', 'NEW JERSEY', 'NEW MEXICO', 'NEW YORK', 'NORTH CAROLINA', 'NORTH DAKOTA', 'OHIO', 'OKLAHOMA', 'OREGON', 'PENNSYLVANIA', 'RHODE ISLAND', 'SOUTH CAROLINA', 'SOUTH DAKOTA', 'TENNESSEE', 'TEXAS', 'UTAH', 'VERMONT', 'VIRGINIA', 'WASHINGTON', 'WEST VIRGINIA', 'WISCONSIN', 'WYOMING', 'GUAM', 'PUERTO RICO', 'VIRGIN ISLANDS', 'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'GU', 'MH', 'MP', 'PW', 'PR', 'VI'];
var provincesABR = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'SK', 'YT', 'QC'];
exports.provincesABR = provincesABR;
var provinces = ['AB', 'BC', 'LB', 'MB', 'NB', 'NF', 'NS', 'NU', 'NW', 'ON', 'PE', 'QC', 'SK', 'YU', 'ALBERTA', 'BRITISH COLUMBIA', 'LABRADOR', 'MANITOBA', 'NEW BRUNSWICK', 'NEWFOUNDLAND', 'NOVA SCOTIA', 'NUNAVUT', 'NORTH WEST TERRITORIES', 'ONTARIO', 'PRINCE EDWARD ISLANDS', 'QUEBEC', 'SASKATCHEWEN', 'YUKON'];
var TestStoreSearch;
exports.TestStoreSearch = TestStoreSearch;

(function (TestStoreSearch) {
  TestStoreSearch["Location"] = "lcelocation";
  TestStoreSearch["Store"] = "lcestore";
})(TestStoreSearch || (exports.TestStoreSearch = TestStoreSearch = {}));

var isTestStore = function isTestStore(query) {
  var _a;

  var lowerQuery = (0, _toLower2["default"])(query);
  return (0, _includes2["default"])(Object.values(TestStoreSearch), (_a = (0, _split2["default"])(lowerQuery, '_')) === null || _a === void 0 ? void 0 : _a[0]);
};

exports.isTestStore = isTestStore;

var compareNoCase = function compareNoCase(string1, string2) {
  return string1.toUpperCase() === string2.toUpperCase();
};

var isPostalCode = function isPostalCode(searchString) {
  return searchString.match(/^(\d{5}(-\d{4})?|[a-zA-Z]\d[a-zA-Z] ?\d[a-zA-Z]\d)$/g);
};

var getPostalCodeFromSet = function getPostalCodeFromSet(searchSet) {
  // if there's only one item check if it's a zipcode
  if (searchSet.length === 1 && isPostalCode(searchSet[0])) {
    return searchSet[0];
  }

  if (searchSet.length > 1) {
    // if there are two or more items items, check if the last two elements combined are a zip code
    var addressCheck = searchSet[searchSet.length - 2] + " " + searchSet[searchSet.length - 1];

    if (isPostalCode(addressCheck)) {
      return addressCheck.toUpperCase();
    } // if there are two or more items items, check if the last element is a zip code


    addressCheck = searchSet[searchSet.length - 1];

    if (isPostalCode(addressCheck)) {
      return addressCheck.toUpperCase();
    }
  } // if we're here -- it should mean there's no match


  return undefined;
};

var getStateProvince = function getStateProvince(set, locations) {
  var match = undefined;
  locations.some(function (item) {
    var two = set.slice(-2).join(' ');
    var one = set.slice(-1).toString();

    if (compareNoCase(item, two)) {
      match = two;
      return true;
    } else if (compareNoCase(item, one)) {
      match = one;
      return true;
    }

    return false;
  });
  return match;
};

var replaceLastIndex = function replaceLastIndex(line, word, replaceString) {
  var pattern = new RegExp("(\\b" + word + "\\b)(?!.*\\b\\1\\b)", 'i');
  return line.replace(pattern, replaceString);
};

var getLocationObject = function getLocationObject(searchString, locale) {
  var searchSet = searchString.replace(',', ' ').split(/\s/);
  var isUS = locale ? locale.toLowerCase().endsWith('us') : true;
  var postalCode = getPostalCodeFromSet(searchSet);
  var province = getStateProvince(replaceLastIndex(searchSet.join(' '), postalCode, '').trim().split(/\s/), isUS ? states : provinces);
  var output = {
    city: undefined,
    province: province,
    zip: postalCode
  };
  var strSet = searchSet.join(' ');

  if (strSet === output.zip) {
    return output;
  }

  if (output.province && output.zip) {
    output.city = replaceLastIndex(replaceLastIndex(strSet, output.zip, ''), output.province, '').trim();
  } else if (output.zip) {
    output.city = replaceLastIndex(strSet, output.zip, '').trim();
  } else if (output.province) {
    output.city = replaceLastIndex(strSet, output.province, '').trim();
  } else {
    output.city = searchString;
  }

  if (output.province && !output.city) {
    output.city = output.province;
    output.province = undefined;
  }

  return output;
};

exports.getLocationObject = getLocationObject;

var getAddressObject = function getAddressObject(query) {
  var addressObject = {
    street: '',
    city: query,
    state: '',
    zip: ''
  };

  if (!query) {
    return {
      address: addressObject
    };
  }

  if (isTestStore(query)) {
    var result = (0, _split2["default"])(query, '_');
    var resultInt = (0, _parseInt2["default"])(result === null || result === void 0 ? void 0 : result[1]);
    var testStoreOption = (0, _toLower2["default"])(result[0]);
    var locationNumber = testStoreOption === TestStoreSearch.Location ? resultInt : 0;
    var franchiseStoreId = testStoreOption === TestStoreSearch.Store ? resultInt : 0;
    return {
      address: {
        city: query
      },
      locationNumber: locationNumber,
      franchiseStoreId: franchiseStoreId
    };
  }

  var AddressTypes;

  (function (AddressTypes) {
    AddressTypes[AddressTypes["ZipCityState"] = 0] = "ZipCityState";
    AddressTypes[AddressTypes["FullAddress"] = 1] = "FullAddress";
    AddressTypes[AddressTypes["StreetCityState"] = 2] = "StreetCityState";
    AddressTypes[AddressTypes["CityStateZip"] = 3] = "CityStateZip";
    AddressTypes[AddressTypes["CityState"] = 4] = "CityState";
    AddressTypes[AddressTypes["Zip"] = 5] = "Zip";
  })(AddressTypes || (AddressTypes = {}));

  var addressMatches = [/^([A-Za-z]\d[A-Za-z][\s-]?\d[A-Za-z]\d|\d{5}|[A-Za-z]\d[A-Za-z]),([\s\w\-#]+),\s*([\w\s]+)$/, /^(\d+[\s\w\-#]+),([\s\w\-#]+),\s*([\w]{2})\s([A-Za-z]\d[A-Za-z][\s-]?\d[A-Za-z]\d|\d{5}|[A-Za-z]\d[A-Za-z])$/, /^(\d+[\s\w\-#]+),([\s\w\-#]+),\s*([\w]{2})$/, /^([\s\w\-#]+),\s([\w{2}]+)\s([A-Za-z]\d[A-Za-z][\s-]?\d[A-Za-z]\d|\d{5}|[A-Za-z]\d[A-Za-z])$/, /^([\s\w\-#]+),\s([\w{2}]+)$/, /^([A-Za-z]\d[A-Za-z][\s-]?\d[A-Za-z]\d$|\d{5}|[A-Za-z]\d[A-Za-z])$/];
  (0, _forEach2["default"])(addressMatches, function (regex, index) {
    var queryMatch = query.match(regex);

    if (queryMatch) {
      switch (index) {
        case AddressTypes.ZipCityState:
          addressObject.zip = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[1];
          addressObject.city = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[2];
          addressObject.state = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[3];
          return false;

        case AddressTypes.FullAddress:
          addressObject.street = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[1];
          addressObject.city = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[2];
          addressObject.state = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[3];
          addressObject.zip = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[4];
          return false;

        case AddressTypes.StreetCityState:
          addressObject.street = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[1];
          addressObject.city = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[2];
          addressObject.state = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[3];
          return false;

        case AddressTypes.CityStateZip:
          addressObject.city = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[1];
          addressObject.state = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[2];
          addressObject.zip = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[3];
          return false;

        case AddressTypes.CityState:
          addressObject.city = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[1];
          addressObject.state = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[2];
          return false;

        case AddressTypes.Zip:
          addressObject.city = '';
          addressObject.zip = queryMatch[1];
          return false;

        default:
          addressObject.city = queryMatch === null || queryMatch === void 0 ? void 0 : queryMatch[1];
          return false;
      }
    }
  });
  return {
    address: {
      street: (0, _trim2["default"])(addressObject.street),
      city: (0, _trim2["default"])(addressObject.city),
      state: (0, _trim2["default"])(addressObject.state),
      zip: (0, _trim2["default"])(addressObject.zip)
    },
    locationNumber: 0,
    franchiseStoreId: 0
  };
};

exports.getAddressObject = getAddressObject;
var ZipPattern = {
  US: /\d{5}(?:[-\s]\d{4})?$/,
  // tslint:disable-next-line: max-line-length
  CA: /^[ABCEGHJ-NPRSTVXYabceghj-nprstvxy]\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z][ -]?\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z]\d$/
};
exports.ZipPattern = ZipPattern;